import { EVersionStage } from "../apiClient/Api";
import { TFunction } from "i18next";

/**
 * Resolves a translated stage label for a version.
 * @param stage - The version stage enum value
 * @param t - Translation function from useTranslation
 * @returns Translated stage label or empty string for RELEASE
 */
export const getStageLabel = (stage: EVersionStage | undefined, t: TFunction): string => {
    switch (stage) {
        case EVersionStage.INTERNAL:
            return t("versionStage.internal");
        case EVersionStage.ALPHA:
            return t("versionStage.alpha");
        case EVersionStage.BETA:
            return t("versionStage.beta");
        case EVersionStage.RELEASE_CANDIDATE:
            return t("versionStage.release_candidate");
        case EVersionStage.RELEASE:
            return t("versionStage.release");
        case EVersionStage.APPROVED:
            return t("versionStage.approved");
        default:
            return "";
    }
};
